export var CLASS_NAME_SHOW = 'show';
export var CLASS_NAME_FADE = 'fade';